<div class="complements__footer">

    <app-footer-list
        [item]="item"
        [items]="displayItems"
    ></app-footer-list>

    <div class="complements__footer-actions">
        <div
            *ngIf="showCounter"
            class="complements__item-counter"
            [class.complements__item-counter--locked]="disabled"
        >
            <button
                class="complements__item-counter-btn"
                [disabled]="disabled"
                (click)="decrement.emit()"
            >−</button>
            <span class="complements__item-counter-val">{{itemQty}}</span>
            <button
                class="complements__item-counter-btn"
                [disabled]="disabled"
                (click)="increment.emit()"
            >+</button>
        </div>

        <button
            class="complements__add-btn"
            [class.complements__add-btn--disabled]="disabled"
            (click)="onAddClick()"
            data-cy="complementsAction"
        >
            <svg *ngIf="showCartIcon" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="9" cy="21" r="1"></circle>
                <circle cx="20" cy="21" r="1"></circle>
                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
            </svg>
            <span>{{buttonLabel}}<ng-container *ngIf="displayPrice > 0">&nbsp;•&nbsp;{{displayPrice | multiCurrency}}</ng-container></span>
        </button>
    </div>

</div>
